
export function langdetector() {

	let lang = location.host.split(".").pop();

	if(lang.indexOf('localhost') != -1){
		lang = "es";
	}

	(lang == 'com') ? lang = 'es' : null;

	return lang;




}


// WEBPACK FOOTER //
// ./src/langdetector/index.js